import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../components/feature/LanguageSwitcher';

export default function CSRPage() {
  const { t } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'マンダラチャートで高校生アスリートを支援｜株式会社LIKES 社会貢献活動 福岡市';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '株式会社LIKESのCSR活動。マンダラチャート認定講師が福岡市の高校生アスリートへ目標設定支援を実施。大谷翔平選手も活用したマンダラチャートで、若者の夢と可能性を広げる次世代育成プログラムです。');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/csr`);
    }
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    const schemas = [
      { id: 'schema-webpage-csr', data: { '@context': 'https://schema.org', '@type': 'WebPage', url: `${siteUrl}/csr`, name: '社会貢献活動 | 株式会社LIKES', inLanguage: 'ja' } },
      { id: 'schema-breadcrumb-csr', data: { '@context': 'https://schema.org', '@type': 'BreadcrumbList', itemListElement: [{ '@type': 'ListItem', position: 1, name: 'ホーム', item: `${siteUrl}/` }, { '@type': 'ListItem', position: 2, name: '社会貢献活動', item: `${siteUrl}/csr` }] } },
    ];
    schemas.forEach(({ id, data }) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(data);
      script.id = id;
      document.head.appendChild(script);
    });
    return () => { schemas.forEach(({ id }) => { document.getElementById(id)?.remove(); }); };
  }, []);

  const mandalaItems = [
    { label: t('vision.pillar1') || 'メンタル強化', icon: 'ri-mental-health-line', center: false },
    { label: '体力向上', icon: 'ri-run-line', center: false },
    { label: '技術習得', icon: 'ri-tools-line', center: false },
    { label: '人間性向上', icon: 'ri-heart-line', center: false },
    { label: '目標\n（中心）', icon: 'ri-focus-3-line', center: true },
    { label: '学業成績', icon: 'ri-book-open-line', center: false },
    { label: 'チームワーク', icon: 'ri-team-line', center: false },
    { label: '生活習慣', icon: 'ri-sun-line', center: false },
    { label: '夢・ビジョン', icon: 'ri-star-line', center: false },
  ];

  const sports = [
    { icon: 'ri-baseball-line', nameKey: 'page.csr.sports.baseball.name', descKey: 'page.csr.sports.baseball.desc', img: 'https://public.readdy.ai/ai/img_res/6ca5120165fbb1e3c91734ede2aa3bfe.jpg' },
    { icon: 'ri-football-line', nameKey: 'page.csr.sports.soccer.name', descKey: 'page.csr.sports.soccer.desc', img: 'https://readdy.ai/api/search-image?query=High%20school%20soccer%20players%20training%20on%20a%20lush%20green%20football%20pitch%2C%20dynamic%20dribbling%20and%20passing%20drills%2C%20coach%20giving%20tactical%20instructions%2C%20afternoon%20sunlight%20with%20long%20shadows%2C%20energetic%20youth%20athletes%20in%20colorful%20uniforms%2C%20team%20coordination%20and%20skill%20development%20atmosphere&width=600&height=400&seq=csr-soccer-001&orientation=landscape' },
    { icon: 'ri-basketball-line', nameKey: 'page.csr.sports.basketball.name', descKey: 'page.csr.sports.basketball.desc', img: 'https://readdy.ai/api/search-image?query=High%20school%20basketball%20players%20practicing%20in%20a%20modern%20gymnasium%2C%20intense%20training%20session%20with%20dribbling%20and%20shooting%20drills%2C%20coach%20demonstrating%20techniques%2C%20bright%20indoor%20lighting%20with%20polished%20hardwood%20floor%2C%20athletic%20youth%20development%20and%20team%20building%2C%20competitive%20sports%20training%20environment&width=600&height=400&seq=csr-basketball-001&orientation=landscape' },
  ];

  const voices = [
    { icon: 'ri-baseball-line', nameKey: 'page.csr.voice1.name', textKey: 'page.csr.voice1.text' },
    { icon: 'ri-football-line', nameKey: 'page.csr.voice2.name', textKey: 'page.csr.voice2.text' },
    { icon: 'ri-user-star-line', nameKey: 'page.csr.voice3.name', textKey: 'page.csr.voice3.text' },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex flex-col leading-none cursor-pointer">
              <span style={{ fontFamily: "'Georgia', 'Times New Roman', serif", letterSpacing: '0.18em' }} className="text-[#255485] font-bold text-2xl tracking-widest uppercase">LIKES</span>
              <span style={{ fontFamily: "'Georgia', 'Times New Roman', serif", letterSpacing: '0.22em' }} className="text-[#255485] text-[9px] font-medium tracking-[0.22em] uppercase mt-0.5">Co, Ltd</span>
            </Link>
            <nav className="hidden md:flex items-center gap-6">
              <Link to="/#vision" className="text-sm text-gray-700 hover:text-[#255485] transition-colors duration-200 cursor-pointer">{t('nav.vision')}</Link>
              <Link to="/#services" className="text-sm text-gray-700 hover:text-[#255485] transition-colors duration-200 cursor-pointer">{t('nav.services')}</Link>
              <Link to="/#csr" className="text-sm text-[#255485] font-semibold cursor-pointer">{t('nav.csr')}</Link>
              <Link to="/#company" className="text-sm text-gray-700 hover:text-[#255485] transition-colors duration-200 cursor-pointer">{t('nav.company')}</Link>
              <LanguageSwitcher />
              <Link to="/#contact" className="bg-[#255485] text-white px-6 py-2.5 rounded-lg hover:bg-[#1d4166] transition-colors duration-200 text-sm font-medium whitespace-nowrap cursor-pointer">{t('nav.contact')}</Link>
            </nav>
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer">
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
          {mobileMenuOpen && (
            <div className="md:hidden border-t border-gray-200 mt-4 pt-4">
              <nav className="flex flex-col space-y-3">
                <div className="flex items-center gap-2 py-1"><span className="text-xs text-gray-500">Language</span><LanguageSwitcher /></div>
                <Link to="/#vision" className="text-sm text-gray-700 hover:text-[#255485] cursor-pointer py-2">{t('nav.vision')}</Link>
                <Link to="/#services" className="text-sm text-gray-700 hover:text-[#255485] cursor-pointer py-2">{t('nav.services')}</Link>
                <Link to="/#csr" className="text-sm text-[#255485] font-semibold cursor-pointer py-2">{t('nav.csr')}</Link>
                <Link to="/#company" className="text-sm text-gray-700 hover:text-[#255485] cursor-pointer py-2">{t('nav.company')}</Link>
                <Link to="/#contact" className="bg-[#255485] text-white px-6 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer text-center">{t('nav.contact')}</Link>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://readdy.ai/api/search-image?query=Young%20high%20school%20baseball%20athletes%20training%20on%20a%20beautiful%20green%20sports%20field%20during%20golden%20hour%2C%20coach%20mentoring%20youth%20players%20with%20passion%20and%20dedication%2C%20team%20spirit%20and%20growth%20mindset%2C%20warm%20sunlight%20casting%20long%20shadows%20across%20the%20field%2C%20inspiring%20youth%20development%20and%20community%20support%20atmosphere%2C%20vibrant%20colors%20with%20soft%20bokeh%20background&width=1600&height=800&seq=csr-hero-bg-001&orientation=landscape" alt="社会貢献活動" className="w-full h-full object-cover object-top" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#255485]/85 via-[#255485]/60 to-transparent"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="max-w-2xl">
            <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <span className="text-white text-sm font-medium tracking-wider">{t('page.csr.hero.badge')}</span>
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif text-white mb-6 leading-tight" style={{ whiteSpace: 'pre-line' }}>{t('page.csr.hero.title')}</h1>
            <p className="text-white/90 text-base md:text-lg leading-relaxed">{t('page.csr.hero.body')}</p>
          </div>
        </div>
      </section>

      {/* Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center">
            <div>
              <p className="text-[#255485] text-sm font-medium tracking-wider mb-3">{t('page.csr.overview.eyebrow')}</p>
              <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-6 leading-tight" style={{ whiteSpace: 'pre-line' }}>{t('page.csr.overview.title')}</h2>
              <p className="text-gray-600 leading-relaxed mb-6">{t('page.csr.overview.body1')}</p>
              <p className="text-gray-600 leading-relaxed mb-8">{t('page.csr.overview.body2')}</p>
              <div className="grid grid-cols-3 gap-4">
                {(['stat1','stat2','stat3'] as const).map((s) => (
                  <div key={s} className="bg-[#255485]/8 rounded-xl p-4 text-center">
                    <p className="text-2xl md:text-3xl font-bold text-[#255485] mb-1">{t(`page.csr.overview.${s}.value`)}</p>
                    <p className="text-xs text-gray-600">{t(`page.csr.overview.${s}.label`)}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="w-full h-[400px] md:h-[480px] rounded-2xl overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=Dedicated%20sports%20coach%20passionately%20mentoring%20a%20group%20of%20young%20high%20school%20athletes%20on%20a%20baseball%20field%2C%20coach%20pointing%20at%20whiteboard%20with%20goal%20setting%20diagrams%2C%20students%20listening%20attentively%20with%20notebooks%2C%20bright%20outdoor%20setting%20with%20green%20grass%2C%20motivational%20and%20educational%20atmosphere%2C%20warm%20natural%20lighting%2C%20community%20support%20and%20youth%20empowerment%20scene&width=800&height=960&seq=csr-overview-001&orientation=portrait" alt="次世代育成支援" className="w-full h-full object-cover object-top" />
            </div>
          </div>
        </div>
      </section>

      {/* Mandala Chart Section */}
      <section className="py-20 bg-[#255485]/8">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-[#255485] text-sm font-medium tracking-wider mb-3">{t('page.csr.mandala.eyebrow')}</p>
            <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-4">{t('page.csr.mandala.title')}</h2>
            <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed">{t('page.csr.mandala.subtitle')}</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center mb-16">
            <div className="relative">
              <div className="bg-white rounded-2xl p-8">
                <h3 className="text-lg font-semibold text-gray-800 mb-6 text-center">{t('page.csr.mandala.chart.title')}</h3>
                <div className="grid grid-cols-3 gap-1.5">
                  {mandalaItems.map((item, i) => (
                    <div key={i} className={`rounded-lg p-3 text-center flex flex-col items-center justify-center gap-1 min-h-[80px] ${item.center ? 'bg-[#255485] text-white' : 'bg-[#255485]/10 text-gray-700'}`}>
                      <div className={`w-7 h-7 flex items-center justify-center ${item.center ? 'text-white' : 'text-[#255485]'}`}>
                        <i className={`${item.icon} text-xl`}></i>
                      </div>
                      <p className={`text-xs font-medium leading-tight whitespace-pre-line ${item.center ? 'text-white' : 'text-gray-700'}`}>{item.label}</p>
                    </div>
                  ))}
                </div>
                <p className="text-xs text-gray-500 text-center mt-4" style={{ whiteSpace: 'pre-line' }}>{t('page.csr.mandala.chart.note')}</p>
              </div>
            </div>
            <div>
              <h3 className="text-2xl font-serif text-gray-900 mb-6" style={{ whiteSpace: 'pre-line' }}>{t('page.csr.mandala.ohtani.title')}</h3>
              <div className="space-y-5">
                {([1,2,3] as const).map((n) => (
                  <div key={n} className="flex gap-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-[#255485] rounded-full flex-shrink-0 mt-0.5">
                      <i className={`ri-number-${n} text-white text-lg`}></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800 mb-1">{t(`page.csr.mandala.step${n}.title`)}</h4>
                      <p className="text-gray-600 text-sm leading-relaxed">{t(`page.csr.mandala.step${n}.desc`)}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="bg-white rounded-2xl overflow-hidden">
            <div className="grid grid-cols-1 md:grid-cols-2">
              <div className="w-full h-[360px] overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=Elite%20professional%20baseball%20pitcher%20in%20action%20on%20a%20major%20league%20baseball%20stadium%20mound%2C%20dynamic%20pitching%20pose%20with%20powerful%20arm%20motion%2C%20dramatic%20stadium%20lighting%20with%20crowd%20in%20background%2C%20professional%20sports%20photography%20style%2C%20athletic%20excellence%20and%20determination%2C%20cinematic%20composition%20with%20shallow%20depth%20of%20field%2C%20inspiring%20sports%20achievement%20concept&width=800&height=720&seq=csr-baseball-player-001&orientation=landscape" alt="プロ野球選手のイメージ" className="w-full h-full object-cover object-top" />
              </div>
              <div className="p-10 flex flex-col justify-center">
                <div className="w-10 h-10 flex items-center justify-center mb-4">
                  <i className="ri-double-quotes-l text-5xl text-[#255485]/30"></i>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed mb-6 italic">{t('page.csr.mandala.quote')}</p>
                <p className="text-gray-500 text-sm">{t('page.csr.mandala.quoteSource')}</p>
                <div className="mt-6 p-4 bg-[#255485]/8 rounded-xl">
                  <p className="text-sm text-gray-700 leading-relaxed">{t('page.csr.mandala.likesNote')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Program */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-[#255485] text-sm font-medium tracking-wider mb-3">{t('page.csr.program.eyebrow')}</p>
            <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-4">{t('page.csr.program.title')}</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">{t('page.csr.program.subtitle')}</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {([['ri-focus-3-line','program1'],['ri-user-heart-line','program2'],['ri-group-line','program3']] as const).map(([icon, key]) => (
              <div key={key} className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow duration-300">
                <div className="w-14 h-14 flex items-center justify-center bg-[#255485]/10 rounded-xl mb-6">
                  <i className={`${icon} text-3xl text-[#255485]`}></i>
                </div>
                <h3 className="text-xl font-serif text-gray-900 mb-4">{t(`page.csr.${key}.title`)}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{t(`page.csr.${key}.desc`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sports */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-[#255485] text-sm font-medium tracking-wider mb-3">{t('page.csr.sports.eyebrow')}</p>
            <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-4">{t('page.csr.sports.title')}</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            {sports.map((s) => (
              <div key={s.nameKey} className="bg-white rounded-xl overflow-hidden hover:shadow-lg transition-shadow duration-300">
                <div className="w-full h-48 overflow-hidden">
                  <img src={s.img} alt={t(s.nameKey)} className="w-full h-full object-cover object-top" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-9 h-9 flex items-center justify-center bg-[#255485]/10 rounded-lg">
                      <i className={`${s.icon} text-xl text-[#255485]`}></i>
                    </div>
                    <h3 className="text-xl font-serif text-gray-900">{t(s.nameKey)}</h3>
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed">{t(s.descKey)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Voices */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-[#255485] text-sm font-medium tracking-wider mb-3">{t('page.csr.voices.eyebrow')}</p>
            <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-4">{t('page.csr.voices.title')}</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {voices.map((v) => (
              <div key={v.nameKey} className="bg-[#255485]/8 rounded-xl p-8">
                <div className="w-10 h-10 flex items-center justify-center mb-4">
                  <i className="ri-double-quotes-l text-4xl text-[#255485]/40"></i>
                </div>
                <p className="text-gray-700 text-sm leading-relaxed mb-6 italic">{t(v.textKey)}</p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#255485] rounded-full">
                    <i className={`${v.icon} text-white text-base`}></i>
                  </div>
                  <p className="text-gray-800 text-sm font-medium">{t(v.nameKey)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-br from-[#255485] to-[#1d4166]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" style={{ whiteSpace: 'pre-line' }}>{t('page.csr.cta.title')}</h2>
          <p className="text-white/90 text-lg mb-8 leading-relaxed" style={{ whiteSpace: 'pre-line' }}>{t('page.csr.cta.body')}</p>
          <Link to="/#contact" className="inline-flex items-center gap-2 bg-white text-[#255485] px-10 py-4 rounded-lg hover:bg-gray-100 transition-colors duration-200 font-medium text-lg cursor-pointer whitespace-nowrap">
            {t('page.csr.cta.button')}<i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1A1A1A] text-white py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-8">
            <div>
              <div className="flex flex-col leading-none mb-4">
                <span style={{ fontFamily: "'Georgia', 'Times New Roman', serif", letterSpacing: '0.18em' }} className="text-white font-bold text-2xl tracking-widest uppercase">LIKES</span>
                <span style={{ fontFamily: "'Georgia', 'Times New Roman', serif", letterSpacing: '0.22em' }} className="text-white/70 text-[9px] font-medium tracking-[0.22em] uppercase mt-0.5">Co, Ltd</span>
              </div>
              <p className="text-white/70 text-sm leading-relaxed" style={{ whiteSpace: 'pre-line' }}>{t('subpage.footer.tagline')}</p>
            </div>
            <div>
              <h3 className="text-white font-semibold mb-4">{t('subpage.footer.nav')}</h3>
              <nav className="space-y-2">
                <Link to="/#vision" className="block text-white/70 hover:text-white text-sm cursor-pointer">{t('nav.vision')}</Link>
                <Link to="/#services" className="block text-white/70 hover:text-white text-sm cursor-pointer">{t('nav.services')}</Link>
                <Link to="/#csr" className="block text-white/70 hover:text-white text-sm cursor-pointer">{t('nav.csr')}</Link>
                <Link to="/#company" className="block text-white/70 hover:text-white text-sm cursor-pointer">{t('nav.company')}</Link>
                <Link to="/#contact" className="block text-white/70 hover:text-white text-sm cursor-pointer">{t('nav.contact')}</Link>
              </nav>
            </div>
            <div>
              <h3 className="text-white font-semibold mb-4">{t('subpage.footer.contact')}</h3>
              <p className="text-white/70 text-sm leading-relaxed mb-4">{t('subpage.footer.address')}</p>
              <Link to="/#contact" className="text-white/70 hover:text-white transition-colors duration-200 text-sm underline cursor-pointer">{t('nav.contact')}</Link>
            </div>
          </div>
          <div className="border-t border-white/10 pt-8 text-center">
            <p className="text-white/50 text-sm">{t('subpage.footer.copyright')}</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
